export default {
  pyConfig: {
    title: 'Plotly Chart',
    xlabel: 'steps',
    ylabel: 'values',
    metrics: ['loss']
  },
  pyCode: `# Comet Python Panels BETA, full documentation available at:
# https://www.comet.com/docs/v2/guides/comet-ui/experiment-management/visualizations/python-panel/

from comet_ml import API, ui
import plotly.express as px

# Initialize Comet API
api = API()

# Get available metrics and select one
available_metrics = api.get_panel_metrics_names()
selected_metric = ui.dropdown("Select a metric:", available_metrics)

# Fetch experiment data 
experiment_keys = api.get_panel_experiment_keys()
if experiment_keys and selected_metric:
    # Fetch the selected metric data for all experiments
    metrics_df = api.get_metrics_df(experiment_keys, [selected_metric])

    # Let's make sure experiments are the right colors
    colors = api.get_panel_experiment_colors()
    if colors:
        colors = {key: value["primary"] for key,value in colors.items()}
    fig = px.line(
        metrics_df,
        x="step",
        y=selected_metric,
        color="experiment_key",
        color_discrete_map=colors,
    )

    # Update layout
    fig.update_layout(
        template="plotly_white",
        showlegend=False,
        xaxis_title=None,
        yaxis_title=None,
    )

    # Display the Plotly figure
    ui.display(fig)
else:
    ui.display("No data to plot. Make sure your metric data is logged by step.")
`,
  pyodideCode: `# Comet Python Panels BETA, full documentation available at:
# https://www.comet.com/docs/v2/guides/comet-ui/experiment-management/visualizations/python-panel/

from comet_ml import API, ui
import matplotlib.pyplot as plt

# Get available metrics
api = API()
metrics = api.get_panel_metrics_names()

# Make chart interactive by adding a dropdown menu
selected_metric = ui.dropdown('Select a metric:', metrics)

# Use API to fetch the metric data for all experiments in the panel scope
experiment_keys = api.get_panel_experiment_keys()
if experiment_keys and selected_metric:
    metrics = api.get_metrics_for_chart(experiment_keys, [selected_metric])

    # Visualize the data
    figure, ax = plt.subplots()
    for experiment_key in metrics:
        for metric in metrics[experiment_key]["metrics"]:
            ax.plot(metric['steps'], metric['values'])

    ui.display(figure)
else:
    ui.display("No data to plot")
`
};
